export function extractPathFromURL(url) {
  const urlParts = url.split("/");
  const lastPart = urlParts[urlParts.length - 1];
  return lastPart;
}
